import React from 'react';
import { connect } from 'react-redux';
import { Modal } from '@beef/ui-kit';
import { resetOrderTariffData } from "../../store/actions/resetOrderTariffData";
import { ModalActionBar } from "./ModalActionBar";
var OrderTariffControl = function OrderTariffControl(_ref) {
  var isOpen = _ref.isOpen,
    children = _ref.children,
    handleClose = _ref.handleClose;
  return /*#__PURE__*/React.createElement(Modal, {
    actionBar: /*#__PURE__*/React.createElement(ModalActionBar, null),
    isOpen: isOpen,
    onClose: handleClose,
    size: "m",
    "data-t-id": "components-OrderTariffControl"
  }, children);
};
var mapDispatchToProps = {
  handleClose: resetOrderTariffData
};
var connector = connect(null, mapDispatchToProps);
var OrderTariffModalWithStore = connector(OrderTariffControl);
export { OrderTariffModalWithStore as OrderTariffControl };